import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static values = {
    href: String,
    dropdownTriggerId: String,
    dropdownContentId: String,
    loaded: Boolean,
  }

  connect() {
    // initialize dropdown
    this.dropdownTrigger = document.getElementById(this.dropdownTriggerIdValue)

    this.instance = M.Dropdown.init(this.dropdownTrigger, {
      closeOnClick: false,
      constrainWidth: false,
      onOpenStart: (opts) => this.handleOpenStart(opts),
      onCloseEnd: (opts) => this.handleCloseEnd(opts) // prevent flickering
    })

    console.log("this.instance", this.instance)
  }

  disconnect() {
    if (this.mouseDownHandler) {
      document.removeEventListener("mousedown", this.mouseDownHandler);
    }
    console.debug("disconnect list_pensenumfrage_columns_dropdown_controller")
  }

  async handleCloseEnd(opts) {
    const dropdownContent = document.getElementById(this.dropdownContentIdValue);
    if (dropdownContent) {
      dropdownContent.innerHTML = '';
    }
    this.loadedValue = false;
  }

  async handleOpenStart(opts) {
    const url = new URL(this.hrefValue, window.location.origin);
    url.searchParams.set('replace_id', this.dropdownContentIdValue);

    const response = await fetch(url, {
      headers: {
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    const html = await response.text()
    Turbo.renderStreamMessage(html)
    this.loadedValue = true
    requestAnimationFrame(() => {
      const renderedContent = this.dropdownTrigger.nextSibling
      this.instance.recalculateDimensions()
      renderedContent.style.top = `${parseFloat(renderedContent.style.top) + 50}px`;
    })
  }

}